shvenergy.phonenumbers = (function ($) {
	"use strict";

	function init() {
        // delegations for lazy loaded elements
        $(document)
 
            .on("click", '.toggle-mobile-numbers', function (e) {
                e.preventDefault();
                e.stopPropagation();
                console.log("den er tændt");

                var phoneNumbersClone = $("#phonenumbers").clone();
                //phoneNumbersClone.slideToggle();
                phoneNumbersClone.attr('id', 'phonenumbersclone');

                $("body").append(phoneNumbersClone);
                $("#phonenumbersclone").show();
            })
            .on("click", '.pop-up--phonenumbers__container__division__close', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $("#phonenumbersclone").remove();
            });

	}

	init();

})(jQuery);